import React, { useState, useEffect } from "react"
import { globalHistory } from "@reach/router"

import { StyledSearch } from "../../styledComponents"
import { getLinkPrefix } from "../../utils/getLinkPrefix"
import SearchIcon from "../../images/search.svg"

export const Search = props => {
  let [searchQuery, changeQuery] = useState("")

  const searchData = e => {
    changeQuery(e.target.value)
  }

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      handleRedirect();
    }
  }

  const handleRedirect = (paramQuery) => {
    //hack to refresh same page with different location
    // const location = globalHistory.location.pathname === "/search/" ? "/support-center/search" : "/support-center/search/"
    const updated_path = globalHistory.location.host === "localhost" ? "" : "/support-center";
    const location = globalHistory.location.pathname === "/search/" ? `${updated_path}${getLinkPrefix('categories', 'search')}` : `${updated_path}/${props.langKey}${getLinkPrefix('categories', 'search')}`;
    const query = paramQuery ? paramQuery : searchQuery;
    globalHistory.navigate(location, {
      state: {
        query: query,
      },
    })
  }

  useEffect(() => {
    if (props.query) {
      changeQuery(props.query);
      handleRedirect(props.query)
    }
  }, []);

  return (
    <StyledSearch
      {...props}
      icon={SearchIcon}
      value={searchQuery}
      onChange={searchData}
      onKeyPress={handleKeyPress}
      placeholder={props.placeholder}
    />
  )
}
